import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ReadPrograms = () => {

  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const API = "https://gp-chandoli-khurd.com/backend/api";

  useEffect(() => {
    fetchPrograms();
  }, []);

  const fetchPrograms = async () => {
    try {

      const res = await fetch(`${API}/program/get_program.php`);
      const data = await res.json();

      if (data.success) {
        setPrograms(data.programs);
      } else {
        setError(data.message || "Failed to fetch programs");
      }

    } catch (err) {
      setError("Error: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteProgram = async (id) => {

    if (!window.confirm("Are you sure you want to delete this program?")) return;

    try {

      const res = await fetch(`${API}/program/delete_program.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ id })
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("Program deleted successfully");
        fetchPrograms();
      } else {
        alert(data.message);
      }

    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return <p className="p-5">Loading programs...</p>;
  if (error) return <p className="text-red-600 p-5">{error}</p>;

  return (

    <div className="max-w-7xl mx-auto">

      <h2 className="text-2xl font-bold mb-6">Programs List</h2>

      {programs.length === 0 && <p>No programs found.</p>}

      <div className="overflow-x-auto">

        <table className="w-full border border-gray-200">

          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">ID</th>
              <th className="p-2 border">Title</th>
              <th className="p-2 border">Date</th>
              <th className="p-2 border">Location</th>
              <th className="p-2 border">Photo</th>
              <th className="p-2 border">Video</th>
              <th className="p-2 border">PDF</th>
              <th className="p-2 border">Actions</th>
            </tr>
          </thead>

          <tbody>

            {programs.map((program) => (

              <tr key={program.id} className="text-center">

                <td className="p-3 border">{program.id}</td>

                <td className="p-3 border font-semibold">
                  {program.title}
                </td>

                <td className="p-3 border">
                  {program.program_date}
                </td>

                <td className="p-3 border">
                  {program.location}
                </td>

                {/* PHOTO */}
                <td className="p-3 border">
                  {program.photo && (
                    <img
                      src={`https://gp-chandoli-khurd.com/backend/uploads/${program.photo}`}
                      alt={program.title}
                      className="w-20 mx-auto rounded"
                    />
                  )}
                </td>

                {/* VIDEO */}
                <td className="p-3 border">
                  {program.video && (
                    <video
                      src={`https://gp-chandoli-khurd.com/backend/uploads/${program.video}`}
                      className="w-24 mx-auto"
                      controls
                    />
                  )}
                </td>

                {/* PDF */}
                <td className="p-3 border">
                  {program.pdf && (
                    <a
                      href={`https://gp-chandoli-khurd.com/backend/uploads/${program.pdf}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      View
                    </a>
                  )}
                </td>

                {/* ACTIONS */}
                <td className="p-3 border space-x-2">

                  <Link
                    to={`/dashboard/programs/update-program/${program.id}`}
                    className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                  >
                    Edit
                  </Link>

                  <button
                    onClick={() => deleteProgram(program.id)}
                    className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                  >
                    Delete
                  </button>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default ReadPrograms;